module.exports = __webpack_public_path__ + "static/media/comment-alt-edit.6bd9076b.svg";